import { Employees } from "components/Condominiums/Employees";

export const ListEmployees = () => {
  return (
    <Employees />
  );
};
